import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { combineFeatureCollections } from './combineFeatureCollections';
import { EMPTY_FEATURE_COLLECTION } from './constants';

/**
 * Convert an array of Blocks to a feature collection
 *
 * @param {Block[]} blocks The blocks to convert
 *
 * @returns {FeatureCollection<Geometry, GeoJsonProperties>} - The blocks converted
 * to a feature collection (empty if there was no geoPolygon data in any of the blocks).
 */
export const convertBlocksToFeatureCollection = (
  blocks: Block[]
): FeatureCollection<Geometry, GeoJsonProperties> => {
  const blockFeatureCollections: FeatureCollection<
    Geometry,
    GeoJsonProperties
  >[] = [];

  blocks?.forEach((block) => {
    if (block.geoPolygon) {
      blockFeatureCollections.push(block.geoPolygon);
    }
  });

  if (blockFeatureCollections.length === 0) {
    return EMPTY_FEATURE_COLLECTION;
  }

  return combineFeatureCollections(blockFeatureCollections);
};
